import useWorkOrdersIsEnabled from 'hooks/feature/work-orders/useWorkOrdersIsEnabled/useWorkOrdersIsEnabled';
import useActivePosition from 'hooks/models/position/useActivePosition';

/**
 * Controls whether the active user can see and access the Work Orders report.
 */
export default function useActiveUserCanManageWorkOrders(): boolean {
  const workOrdersIsEnabled = useWorkOrdersIsEnabled();
  const activePosition = useActivePosition();

  return workOrdersIsEnabled && activePosition?.manageWorkOrders === true;
}
